var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2988 10.5866C16.2993 10.3401 16.3654 10.0983 16.4903 9.88582C16.6152 9.67339 16.7945 9.49807 17.0096 9.37787C17.2248 9.25768 17.468 9.19695 17.7144 9.20194C17.9608 9.20694 18.2014 9.27746 18.4115 9.40627L25.1899 13.5669C25.3919 13.6911 25.5588 13.8649 25.6745 14.0718C25.7902 14.2788 25.851 14.512 25.851 14.7491C25.851 14.9862 25.7902 15.2193 25.6745 15.4263C25.5588 15.6332 25.3919 15.8071 25.1899 15.9312L18.4115 20.0937C18.2012 20.2227 17.9602 20.2932 17.7135 20.2981C17.4668 20.3029 17.2233 20.2418 17.008 20.1212C16.7927 20.0006 16.6136 19.8247 16.4889 19.6118C16.3642 19.3988 16.2986 19.1565 16.2988 18.9097V10.5866Z",
    stroke: "#5C5C77",
    strokeWidth: 2.37179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.7017V35.1017",
    stroke: "#5C5C77",
    strokeWidth: 2.37179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6016 35.1021H27.4016",
    stroke: "#5C5C77",
    strokeWidth: 2.37179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8 1.80078H5.2C3.15655 1.80078 1.5 3.45733 1.5 5.50078V24.0008C1.5 26.0442 3.15655 27.7008 5.2 27.7008H34.8C36.8435 27.7008 38.5 26.0442 38.5 24.0008V5.50078C38.5 3.45733 36.8435 1.80078 34.8 1.80078Z",
    stroke: "#5C5C77",
    strokeWidth: 2.37179,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOutline);
export default __webpack_public_path__ + "static/media/videoOutline.38f3da457c46da4b28eb8398309f69fa.svg";
export { ForwardRef as ReactComponent };